module.exports = __webpack_public_path__ + "img/closing_balance.869b1829.png";